interface NavTranslation {
  home: string;
  services: string;
  process: string;
  pricing: string;
  contact: string;
  faq?: string;
}

// Dashboard translation interface
interface DashboardTranslation {
  title: string;
  hello: string;
  language: string;
  logout: string;
  closeMenu: string;
  defaultUser: string;
  items: {
    booking: string;
    cart: string;
    orders: string;
    events: string;
    shorts: string;
    subscription: string;
    payments: string;
    profile: string;
  };
  booking?: {
    steps: {
      serviceTitle: string;
      serviceSubtitle: string;
      quantityTitle: string;
      planningTitle: string;
      confirmTitle: string;
    };
    labels: {
      loadingServices: string;
      servicesError: string;
      duration: string;
      days: string;
      hours: string;
      pickupIncluded: string;
      pickupNotIncluded: string;
      requirements: string;
      limitations: string;
      pickupUpgradeBadge: string;
      clickToViewDetails: string;
      features: string;
      readMore: string;
      readLess: string;
      popular: string;
      customizable: string;
      addOptionsNext: string;
      customizeTitle: string;
      pairsLabel: string;
      summaryTitle: string;
      discountLine: string;
      optionsLine: string;
      totalLine: string;
      youSave: string;
      howManyPairs: string;
      unitPrice: string;
      estimate: string;
      totalInclTax: string;
      maxPairsNote: string;
      pickupQuestion: string;
      pickupUpgradeAdded: string;
      pickupUpgradeLine: string;
      savings: string;
      total: string;
      includedTitle: string;
      addressTitle: string;
      useSavedAddress: string;
      useMyAddress?: string;
      addressOutOfZone: string;
      addressPlaceholder: string;
      addressHint: string;
      pickupSlotTitle: string;
      pickupDateLabel: string;
      selected: string;
      selectedPrefix: string;
      timeSlotLabel: string;
      specialInstructionsLabel: string;
      specialInstructionsPlaceholder: string;
      relayChooseTitle: string;
      relayInfoAlert: string;
      relaySearchPlaceholder: string;
      relayCityPlaceholder: string;
      relayPostalPlaceholder: string;
      relayLoading: string;
      relayEmpty: string;
      openingHours: string;
      pageLabel: string;
      stepperAria: string;
      progressSrPrefix: string;
      stepPrefix: string;
      ofWord: string;
      confirmationTitle: string;
      serviceSummaryTitle: string;
      estimatedTotal: string;
      priceDetailsTitle: string;
      priceService: string;
      pricePickupOption: string;
      priceTotal: string;
      paymentNote: string;
      pickupDetailsTitle: string;
      pickupHomeBadge: string;
      relayBadge: string;
      relayDeadlineNote: string;
      relayDeadlineLabel: string;
      specialInstructionsTitle: string;
      submitCreating: string;
      submitConfirm: string;
      proceedToPayment: string;
      processingPayment: string;
      confirmEmailNote: string;
      headerTitle: string;
      headerSubtitle: string;
      cancelDraft: string;
      cancelDraftTitle: string;
      cancelDraftDesc: string;
      cancelContinue: string;
      cancelConfirm: string;
      calendarPrevMonth: string;
      calendarNextMonth: string;
      markerPickupAria: string;
      markerDeliveryAria: string;
      successTitle: string;
      successSubtitle: string;
      orderNumberLabel: string;
      totalLabel: string;
      methodLabel: string;
      methodPickupFull: string;
      methodRelay: string;
      nextStepsTitle: string;
      nextStepsEmailTo: string;
      nextStepsPickup: string;
      nextStepsRelayCollect: string;
      nextStepsRelayDepositPrefix: string;
      nextStepsRelayDepositSuffix: string;
      nextStepsNotified: string;
      continueButton: string;
      myOrdersButton: string;
      phoneLabel?: string;
      phoneHint?: string;
      pickupDeliveryTitle?: string;
      confirmSubtitle?: string;
      // Step 2 guard when service missing
      step2ServiceMissingTitle?: string;
      step2ServiceMissingDesc?: string;
      step2ServiceMissingRefresh?: string;
      // Deal suggestion compact texts
      dealSuggest?: {
        belowMin: {
          titlePrefix: string;
          add: string;
          pairs: string;
          qualify: string;
          ctaPrefix: string;
          ctaPairs: string;
        };
        exactlyBuy: {
          title: string;
          body: string;
          ctaPrefix: string;
          ctaSuffix: string;
        };
      };
    };
  };
  orders?: {
    title: string;
    filters: {
      statusAll: string;
      statusLabel: string;
      dateLabel: string;
      selectDate: string;
      reset: string;
      filters: string;
      countSuffix: string;
    };
    empty: string;
    header: {
      order: string; // "Commande" / "Order"
      dateUnavailable: string;
    };
    labels: {
      pairsSuffix: string; // suffix for pluralization like "s"
      homePickup: string;
      relayPoint: string;
      pickupPlanned: string;
      pickupSlot: string;
      pickupMethod: string;
      estimatedReturn: string;
      relayReturnEstimated: string;
      relayDepositAssumption: string;
      deliverySlot: string;
      instructionsPrefix: string; // "Instructions:"
      total: string;
      details: string;
      hide: string;
      contactSupport: string;
      page: string;
      of: string;
      prev: string;
      next: string;
      cancelConfirm: string;
      cancelSuccess: string;
      cancelError: string;
    };
    status: {
      pending: string;
      pickup_scheduled: string;
      in_progress: string;
      delivery_scheduled: string;
      completed: string;
      cancelled: string;
    };
  };
  events?: {
    title: string;
    instructions: {
      selectDate: string;
    };
    legend: {
      title: string;
      pickup: string;
      delivery: string;
      relayPending: string;
    };
    headers: {
      upcoming: string;
      past: string;
    };
    empty: {
      forDate: string;
      planned: string;
    };
    modal: {
      collectDetails: string;
      deliveryDetails: string;
      eventDetails: string;
      close: string;
      reschedule: string;
    };
    labels: {
      date: string;
      slot: string;
      method: string;
      amount: string;
      address: string;
      relayPoint: string;
      additionalInfo: string;
      relayPickup: string;
      relaySpotName: string;
      relaySpotAddress: string;
      relaySpotContact: string;
      pickupMethod: string;
      deliveryMethod: string;
      instructions: string;
      none: string;
      homePickup: string;
      order: string;
      pair: string;
      pairs: string;
      collect: string;
      deliveryScheduled: string;
      showAll: string;
      calendar: string;
    };
  };
  payments?: {
    title: string;
    subtitle: string;
    loading: string;
    errorFallback: string;
    noPayments: string;
    downloadReceipt: string;
    showingRecent: string;
    summary: {
      totalPaid: string;
      pending: string;
      transactions: string;
    };
    history: {
      title: string;
      empty: string;
      table: {
        order: string;
        date: string;
        method: string;
        amount: string;
        status: string;
        actions: string;
      };
      actions: {
        pay: string;
        viewReceipt: string;
        downloadReceipt: string;
      };
      pagination: {
        none: string;
        perPage: string;
        prev: string;
        next: string;
        display: string; // template like "Affichage {start}–{end} sur {total}"
      };
    };
    methods: {
      credit_card: string;
      card: string;
      manual: string;
      bank_transfer: string;
      paypal: string;
      stripe: string;
    };
    status: {
      paid: string;
      pending: string;
      failed: string;
      refunded: string;
      refund_pending: string;
    };
  };
  profile?: {
    title: string;
    subtitle?: string;
    connectedVia?: string;
    loading: string;
    loadError: string;
    successUpdate: string;
    updateError: string;
    picture: {
      change: string;
    };
    info: {
      title: string;
      subtitle?: string;
      edit: string;
      save: string;
      cancel: string;
      fields: {
        firstName: string;
        lastName: string;
        email: string;
        emailManagedBy: string; // contains {provider}
        phone: string;
        address: string;
        city: string;
        postalCode: string;
        addressPlaceholder: string;
      };
      viewLabels: {
        fullName: string;
        phoneUnknown: string;
        addressUnknown: string;
      };
    };
    security: {
      title: string;
      subtitle?: string;
      changePassword: string;
      connectedVia: string; // contains {provider}
      oauthAccount: string; // contains {provider}
      oauthSecuredBy: string; // contains {provider}
      form: {
        current: string;
        new: string;
        confirmNew: string;
        submit: string;
        cancel: string;
        mismatch: string;
        changeSuccess: string;
        changeError: string;
        changeErrorWithHint: string;
      };
    };
    actions: {
      title: string;
      subtitle?: string;
      logout: {
        title: string;
        description: string;
        error: string;
      };
      delete: {
        title: string;
        description: string;
      };
    };
  };
  reschedule?: {
    pickupSection: {
      title: string;
      dateLabel: string;
      addressLabel: string;
    };
    deliverySection: {
      title: string;
      dateLabel: string;
      estimatedDateLabel: string;
      selectPickupFirst: string;
      estimatedDays: string;
      estimatedPrefix: string;
      estimatedSuffix: string;
      addressLabel: string;
    };
    selected: string;
    timeSlotLabel: string;
    addressPlaceholder: string;
    deliveryAddressPlaceholder: string;
    serviceZone: string;
    errors: {
      addressOutOfZone: string;
      earlierDate: string;
      earlierTimeSlot: string;
    };
  };
  // Deals banner (optional)
  deals?: {
    banner: {
      datePrefix: string; // e.g., "📅 Du"
      dateConnector: string; // e.g., "au"
    };
  };
}

interface CommonTranslation {
  prev: string;
  next: string;
  pair: string;
  perPair: string;
  hide: string;
  loading: string;
  cancel: string;
  confirm: string;
}

interface HeroTranslation {
  title: string;
  slogan: string;
  description: string;
  cta: string;
  benefits?: {
    collection: string;
    express: string;
    luxury: string;
  };
  stats?: {
    express: string;
    pairs: string;
    rating: string;
  };
  trustBadge?: string;
  testimonial?: string;
}

interface ServiceItem {
  title: string;
  description: string;
}

interface ServicesTranslation {
  title: string;
  learnMore: string;
  items: ServiceItem[];
}

interface ProcessStep {
  title: string;
  description: string;
}

interface ImpactTranslation {
  title: string;
  subtitle: string;
  cards: {
    lifespan: { title: string; description: string };
    environmental: { title: string; description: string };
    time: { title: string; description: string };
  };
  categories: {
    personal: { title: string; description: string };
    health: { title: string; description: string };
    environmental: { title: string; description: string };
    economic: { title: string; description: string };
  };
  stats: {
    lifespan: { value: string; label: string };
    water: { value: string; label: string };
    waste: { value: string; label: string };
    satisfaction: { value: string; label: string };
  };
}

interface PricingPlan {
  name: string;
  price: string;
  description: string;
  features: string[];
  cta: string;
}

interface PricingTranslation {
  title: string;
  duration: string;
  popular: string;
  choose: string;
  savings: string;
  pickup: string;
  requirements: string;
  limitations: string;
  description: string;
  customService: string;
  contactUs: string;
  pickupUpgrade: string;
  toggle?: {
    services: string;
    subscriptions: string;
  };
  subscriptions?: {
    month: string;
    monthly: string;
    quarterly: string;
    yearly: string;
    equivalent: string;
    credits: string;
    creditsPerMonth: string;
    cleaningsPerMonth: string;
    cleaning: string;
    forCleaningsPerMonth: string;
    serviceValue: string;
    includedFeatures: string;
    subscribe: string;
    forService: string;
    plansFor: string;
    noEngagement: string;
    needHelp: string;
    helpDescription: string;
  };
  plans: PricingPlan[];
}

interface ContactTranslation {
  title: string;
  subtitle: string;
  infoTitle: string;
  form: {
    title: string;
    name: string;
    email: string;
    phone: string;
    service: string;
    message: string;
    submit: string;
    success: string;
    placeholders: {
      name: string;
      email: string;
      phone: string;
      message: string;
    };
  };
  info: {
    phone: string;
    email: string;
    address: string;
    hours: string;
  };
  infoLabels: {
    phone: string;
    email: string;
    address: string;
    hours: string;
  };
}

interface FooterTranslation {
  about: {
    title: string;
    description: string;
  };
  services: {
    title: string;
    items: string[];
  };
  contact: {
    title: string;
    phone: string;
    email: string;
    address: string;
  };
  social: {
    title: string;
  };
  copyright: string;
  bottomLinks?: {
    privacy: string;
    terms: string;
    legal: string;
    faq: string;
  };
}

interface ServiceAreaTranslation {
  title: string;
  subtitle: string;
  legend: {
    center: string;
    covered: string;
    coverageZone: string;
  };
  coveredHeading: string;
  availableLabel: string;
  popup: {
    departmentPrefix: string;
    serviceAvailable: string;
  };
  cta: {
    notCoveredQuestion: string;
    contactUs: string;
  };
}

interface ServiceDetailTranslation {
  notFound: string;
  backToServices: string;
  summary: string;
  duration: string;
  price: string;
  guarantee: string;
  detailedDescription: string;
  ourProcess: string;
  materialsHandled: string;
  importantPrecautions: string;
  serviceLimits: string;
  bookService: string;
}

interface CatalogItem {
  title: string;
  description: string;
}

interface CatalogTranslation {
  badge: string;
  title: string;
  subtitle: string;
  before: string;
  after: string;
  previous: string;
  next: string;
  instructions: string;
  viewMore: string;
  pageTitle: string;
  pageSubtitle: string;
  backToHome: string;
  seeResult: string;
  seeBefore: string;
  transforming: string;
  items: CatalogItem[];
}

interface SubscriptionsTranslation {
  badge: string;
  title: string;
  subtitle: string;
  loading: string;
  popular: string;
  billing: {
    monthly: string;
    quarterly: string;
    yearly: string;
  };
  equivalent: string;
  creditsPerCycle: string;
  subscribe: string;
  forService: string;
  needHelp: string;
  contactUs: string;
}

interface SubscriptionDashboardTranslation {
  title: string;
  subtitle: string;
  refresh: string;
  creditsBalance: string;
  creditsByService: string;
  nextRenewal: string;
  currentPlan: string;
  monthlyPrice: string;
  month: string;
  creditsPerMonth: string;
  periodStart: string;
  periodEnd: string;
  cleanings: string;
  credit: string;
  credits: string;
  noSubscription: string;
  noSubscriptionText: string;
  viewPlans: string;
  availablePlans: string;
  choosePlan: string;
  noPlansAvailable: string;
  popular: string;
  select: string;
  noEngagement: string;
  backToPlans: string;
  confirmSubscription: string;
  reviewDetails: string;
  billing: string;
  monthly: string;
  includedFeatures: string;
  termsTitle: string;
  termsText: string;
  proceedToPayment: string;
  paymentError: string;
  cancel: string;
  cancelConfirmText: string;
  cancelAtPeriodEnd: string;
  cancelImmediately: string;
  keepSubscription: string;
  cancelledAtPeriodEnd: string;
  cancelledImmediately: string;
  cancelError: string;
  cancelAtPeriodEndWarning: string;
  cancelAtPeriodEndDate: string;
  resume: string;
  resumed: string;
  resumeError: string;
  creditHistory: string;
  noHistory: string;
  subscriptionSuccess: string;
  continue: string;
  confirmSubtitle: string;
  features: string;
  requirements: string;
  limitations: string;
  status: {
    active: string;
    cancelled: string;
    pastDue: string;
    paused: string;
  };
  history: {
    grant: string;
    use: string;
    expire: string;
    refund: string;
  };
  // Subscription booking flow
  bookCleaning: string;
  creditsAvailable: string;
  creditsRemaining: string;
  bookCleaningTitle: string;
  selectQuantity: string;
  howManyPairs: string;
  youHave: string;
  pair: string;
  pairs: string;
  creditWillBeUsed: string;
  creditsWillBeUsed: string;
  addPickupUpgrade: string;
  pickupUpgradeDescription: string;
  pickupDetails: string;
  confirmBooking: string;
  reviewYourBooking: string;
  service: string;
  quantity: string;
  creditsUsed: string;
  pickupSupplement: string;
  pickupMethod: string;
  supplementRequired: string;
  supplementDescription: string;
  confirmAndPay: string;
  bookingSuccess: string;
  bookingError: string;
}

interface LanguageTranslation {
  nav: NavTranslation;
  hero: HeroTranslation;
  services: ServicesTranslation;
  impact: ImpactTranslation;
  pricing: PricingTranslation;
  contact: ContactTranslation;
  footer: FooterTranslation;
  serviceArea?: ServiceAreaTranslation;
  auth?: any;
  common?: CommonTranslation;
  dashboard?: DashboardTranslation;
  serviceDetail?: ServiceDetailTranslation;
  catalog?: CatalogTranslation;
  subscriptions?: SubscriptionsTranslation;
  subscription?: SubscriptionDashboardTranslation;
  shots?: {
    badge: string;
    title: string;
    subtitle: string;
    unmute: string;
    mute: string;
    viewMore: string;
    pageTitle: string;
    pageSubtitle: string;
    back: string;
  };
}

interface Translations {
  fr: LanguageTranslation;
  en: LanguageTranslation;
}

export const translations: Translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      process: "Impact",
      pricing: "Tarifs",
      contact: "Contact",
      faq: "FAQ",
    },

    // Common
    common: {
      prev: "Précédent",
      next: "Suivant",
      pair: "paire",
      perPair: "par paire",
      hide: "Masquer",
      loading: "Chargement...",
      cancel: "Annuler",
      confirm: "Confirmer",
    },

    // Hero Section
    hero: {
      title: "Tes baskets ne sont pas vieilles, elles sont juste sales",
      slogan: "Redonnez vie à vos chaussures préférées",
      description:
        "Composez votre nettoyage sur mesure : choisissez votre service de base, ajoutez vos options — ou demandez un devis personnalisé en photos.",
      cta: "Composer ma prestation",
      benefits: {
        collection: "Collecte & livraison en option",
        express: "Express 48h disponible",
        luxury: "Devis photo gratuit",
      },
      stats: {
        express: "Express",
        pairs: "Paires traitées",
        rating: "Note moyenne",
      },
      trustBadge: "4.9/5 - 1k+ paires ravivées",
      testimonial: '⭐⭐⭐⭐⭐ "Incroyable résultat !"',
    },

    // Services Section
    services: {
      title: "Nos Services",
      learnMore: "En savoir plus",
      items: [
        {
          title: "Nettoyage Professionnel",
          description:
            "Nettoyage en profondeur avec des produits spécialisés pour tous types de chaussures",
        },
        {
          title: "Collecte & Livraison",
          description:
            "Option : on vient chercher vos paires et on les ramène, dès 15€",
        },
        {
          title: "Service Express",
          description: "Option : traitement prioritaire, retour en 24h ou 48h",
        },
        {
          title: "Protection Premium",
          description: "Option : imperméabilisation longue durée, dès 2€ par paire",
        },
        {
          title: "Finition Luxe",
          description:
            "Finition haut de gamme avec cirage premium et emballage soigné",
        },
        {
          title: "Entreprises",
          description:
            "Nettoyage de sneakers en volume pour les professionnels : collecte sur site et facturation mensuelle",
        },
      ],
    },

    // Process Section
    impact: {
      title: "Notre Impact",
      subtitle:
        "Chaque année, 24 milliards de chaussures sont produites. 90% finissent en décharge. Ensemble, changeons la donne.",
      cards: {
        lifespan: {
          title: "1000 ans en décharge",
          description:
            "Une semelle synthétique met jusqu'à 1000 ans à se décomposer. En prolongeant la vie de vos chaussures de 2-3 ans, vous évitez qu'elles rejoignent les 300 millions de paires jetées chaque année en France.",
        },
        environmental: {
          title: "13,6 kg de CO₂ par paire",
          description:
            "Chaque paire neuve génère 13,6 kg de CO₂ et consomme 8000 litres d'eau (MIT). L'industrie de la chaussure représente 1,4% des émissions mondiales — autant que le transport aérien. Entretenir, c'est agir.",
        },
        time: {
          title: "Votre temps est précieux",
          description:
            "Collecte et livraison à domicile : zéro déplacement, zéro file d'attente. Retrouvez vos chaussures comme neuves sans effort, pendant que vous profitez de votre temps libre.",
        },
      },
      categories: {
        personal: {
          title: "Apparence",
          description:
            "Des chaussures impeccables qui reflètent votre style et votre professionnalisme",
        },
        health: {
          title: "Hygiène",
          description:
            "Élimination des bactéries et allergènes pour des pieds plus sains",
        },
        environmental: {
          title: "Planète",
          description:
            "Prolongez la vie de vos chaussures et réduisez les déchets textiles",
        },
        economic: {
          title: "Économie",
          description:
            "Économisez en entretenant plutôt qu'en remplaçant vos chaussures",
        },
      },
      stats: {
        lifespan: {
          value: "+3 ans",
          label: "Durée de vie prolongée",
        },
        water: {
          value: "8000L",
          label: "D'eau économisés par paire",
        },
        waste: {
          value: "13,6kg",
          label: "De CO₂ évités par paire",
        },
        satisfaction: {
          value: "98%",
          label: "Clients satisfaits",
        },
      },
    },

    // Pricing Section
    pricing: {
      title: "Nos Tarifs",
      duration: "Durée estimée:",
      popular: "Populaire",
      choose: "Choisir",
      savings: "Économisez",
      pickup: "Collecte et livraison incluses",
      requirements: "Conditions requises",
      limitations: "Limitations",
      description: "3 services de base, vos options en plus.",
      customService: "Besoin d'un service personnalisé?",
      contactUs: "Contactez-nous",
      pickupUpgrade: "Collecte & livraison disponible en option",
      toggle: {
        services: "Services",
        subscriptions: "Abonnements",
      },
      subscriptions: {
        month: "mois",
        monthly: "/ mois",
        quarterly: "/ trimestre",
        yearly: "/ an",
        equivalent: "soit {price} / mois",
        credits: "crédits inclus",
        creditsPerMonth: "crédits / mois",
        cleaningsPerMonth: "nettoyages / mois",
        cleaning: "nettoyage",
        forCleaningsPerMonth: "pour {count} nettoyages par mois",
        serviceValue: "valeur {price} / crédit",
        includedFeatures: "Ce qui est inclus",
        subscribe: "S'abonner",
        forService: "Pour le service : {service}",
        plansFor: "Abonnements pour",
        noEngagement: "Sans engagement, résiliable à tout moment",
        needHelp: "Besoin d'aide ?",
        helpDescription:
          "Nos conseillers sont là pour vous aider à choisir l'abonnement adapté à vos besoins.",
      },
      plans: [
        {
          name: "Essentiel",
          price: "20€",
          description: "Nettoyage standard pour usage quotidien",
          features: [
            "Nettoyage professionnel",
            "Collecte & livraison",
            "Délai standard 1 semaine",
            "Garantie satisfaction",
          ],
          cta: "Choisir ce plan",
        },
        {
          name: "Premium",
          price: "20€",
          description: "Nettoyage approfondi avec protection",
          features: [
            "Nettoyage professionnel",
            "Collecte & livraison",
            "Service express 4 jours",
            "Protection imperméabilisante",
            "Emballage premium",
            "Garantie satisfaction",
          ],
          cta: "Choisir ce plan",
        },
        {
          name: "Luxe",
          price: "45€",
          description: "Service ultra-rapide premium",
          features: [
            "Nettoyage professionnel",
            "Collecte & livraison",
            "Service express 24h",
            "Protection imperméabilisante",
            "Réparations mineures",
            "Cirage premium",
            "Emballage luxe",
            "Garantie satisfaction",
          ],
          cta: "Choisir ce plan",
        },
      ],
    },

    // Contact Section
    contact: {
      title: "Contactez-nous",
      subtitle: "Prêt à redonner vie à vos chaussures ?",
      infoTitle: "Informations de Contact",
      form: {
        title: "Envoyez-nous un message",
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone",
        service: "Service souhaité",
        message: "Message",
        submit: "Envoyer le message",
        success: "Merci pour votre message ! Nous vous contacterons bientôt.",
        placeholders: {
          name: "Votre nom",
          email: "votre@email.com",
          phone: "+33 1 23 45 67 89",
          message: "Décrivez vos besoins...",
        },
      },

      info: {
        phone: "",
        email: "contact@lavetesbaskets.fr",
        address: "Paris, France",
        hours: "Lun-Dim: 8h-19h",
      },
      infoLabels: {
        phone: "Téléphone",
        email: "Email",
        address: "Adresse",
        hours: "Horaires",
      },
    },

    // Footer Section
    footer: {
      about: {
        title: "À Propos",
        description:
          "Lave Tes Baskets est votre service de nettoyage professionnel de chaussures. Nous redonnons vie à vos baskets préférées avec des techniques de nettoyage avancées.",
      },
      services: {
        title: "Services",
        items: [
          "Nettoyage Professionnel",
          "Collecte & Livraison",
          "Service Express",
          "Protection Premium",
          "Réparation",
          "Finition Luxe",
        ],
      },
      contact: {
        title: "Contact",
        phone: "",
        email: "contact@lavetesbaskets.fr",
        address: "Paris, France",
      },
      social: {
        title: "Suivez-nous",
      },
      copyright: "© 2024 Lave Tes Baskets. Tous droits réservés.",
      bottomLinks: {
        privacy: "Politique de confidentialité",
        terms: "Conditions d'utilisation",
        legal: "Mentions légales",
        faq: "FAQ",
      },
    },
    // Dashboard Section
    dashboard: {
      title: "Tableau de bord",
      hello: "Bonjour",
      language: "Langue",
      logout: "Déconnexion",
      closeMenu: "Fermer le menu",
      defaultUser: "Utilisateur",
      items: {
        booking: "Nettoyages",
        cart: "Panier",
        orders: "Commandes",
        events: "Événements",
        shorts: "Lavages",
        subscription: "Abonnements",
        payments: "Paiements",
        profile: "Profil",
      },
      // Deals banner translations
      deals: {
        banner: {
          datePrefix: "📅 Du",
          dateConnector: "au",
        },
      },
      booking: {
        steps: {
          serviceTitle: "Choisissez votre service de nettoyage",
          serviceSubtitle:
            "Sélectionnez le service qui correspond le mieux à vos besoins",
          quantityTitle: "Combien de paires souhaitez-vous faire nettoyer ?",
          planningTitle: "Collecte & Planning",
          confirmTitle: "Confirmation",
        },
        labels: {
          loadingServices: "Chargement des services...",
          servicesError: "Erreur lors du chargement des services",
          duration: "Durée :",
          days: "jours",
          hours: "heures",
          pickupIncluded: "Collecte & livraison ✅",
          pickupNotIncluded: "❌ Collecte & livraison",
          requirements: "Conditions requises",
          limitations: "Limitations",
          pickupUpgradeBadge: "+10€ pour collecte & livraison",
          clickToViewDetails: "Cliquez pour voir les détails",
          features: "Services inclus",
          readMore: "Lire plus",
          readLess: "Voir moins",
          popular: "Populaire",
          customizable: "Personnalisable",
          addOptionsNext: "Ajoutez vos options à l'étape suivante",
          customizeTitle: "Composez votre prestation",
          pairsLabel: "Nombre de paires",
          summaryTitle: "Récapitulatif",
          discountLine: "Réduction",
          optionsLine: "Options",
          totalLine: "Total",
          youSave: "Vous économisez",
          howManyPairs: "Combien de paires souhaitez-vous faire nettoyer ?",
          unitPrice: "Prix unitaire",
          estimate: "Devis",
          totalInclTax: "Total TTC",
          maxPairsNote: "Maximum 100 paires par commande",
          pickupQuestion: "Souhaitez-vous la collecte & livraison ?",
          pickupUpgradeAdded: "+10€ ajoutés au total",
          pickupUpgradeLine: "Collecte & livraison",
          savings: "Économies",
          total: "Total",
          includedTitle: "Ce qui est inclus :",
          addressTitle: "Adresse de collecte & livraison",
          useSavedAddress: "Utiliser mon adresse enregistrée",
          useMyAddress: "Utiliser mon adresse",
          addressOutOfZone:
            "Adresse hors zone de service. Nous couvrons uniquement l'Île-de-France (75, 77, 78, 91, 92, 93, 94, 95).",
          addressPlaceholder:
            "Entrez votre adresse complète (rue, ville, code postal)...",
          addressHint:
            "Assurez-vous que l'adresse est correcte pour une collecte sans retard.",
          phoneLabel: "Téléphone",
          phoneHint:
            "Nous utiliserons ce numéro pour vous contacter au besoin.",
          pickupDeliveryTitle: "Retrait & Livraison",
          pickupSlotTitle: "Créneau de collecte",
          pickupDateLabel: "Date de collecte",
          selected: "Sélectionné",
          selectedPrefix: "Sélectionné:",
          timeSlotLabel: "Créneau horaire",
          specialInstructionsLabel: "Instructions spéciales (optionnel)",
          specialInstructionsPlaceholder:
            "Précisions sur l'accès, étage, code, etc...",
          relayChooseTitle: "Choisissez votre point relais",
          relayInfoAlert:
            "Ce service ne propose pas la collecte & livraison à domicile. Déposez vos chaussures dans l'un de nos points relais partenaires sous 48h maximum pour permettre leur collecte par notre équipe.",
          relaySearchPlaceholder: "Recherche (adresse, ville, code postal)",
          relayCityPlaceholder: "Ville",
          relayPostalPlaceholder: "Code postal",
          relayLoading: "Chargement des points relais...",
          relayEmpty:
            "Aucun point relais trouvé avec ces critères. Essayez d'élargir votre recherche.",
          openingHours: "Horaires d'ouverture",
          pageLabel: "Page",
          stepperAria: "Étapes de la commande",
          progressSrPrefix: "Progression",
          stepPrefix: "Étape",
          ofWord: "sur",
          confirmationTitle: "Confirmation de votre commande",
          serviceSummaryTitle: "Récapitulatif du service",
          estimatedTotal: "Total estimé",
          priceDetailsTitle: "Détail du prix",
          priceService: "Service",
          pricePickupOption: "Option collecte & livraison",
          priceTotal: "Total",
          paymentNote: "Le paiement se fera à l'étape suivante.",
          pickupDetailsTitle: "Détails de collecte",
          pickupHomeBadge: "Collecte & livraison à domicile",
          relayBadge: "Point relais",
          relayDeadlineNote:
            "Délais: vous disposez de 48h maximum pour déposer vos chaussures au point relais choisi après confirmation de la commande.",
          relayDeadlineLabel: "Date limite de dépôt:",
          specialInstructionsTitle: "Instructions spéciales",
          submitCreating: "Création en cours...",
          submitConfirm: "Confirmer ma commande",
          proceedToPayment: "Procéder au paiement",
          processingPayment: "Traitement en cours...",
          confirmEmailNote:
            "Vous recevrez un email de confirmation avec le récapitulatif de votre commande.",
          headerTitle: "Nouvelle commande de nettoyage",
          headerSubtitle:
            "Configurez votre service de nettoyage en quelques étapes simples",
          cancelDraft: "Annuler le brouillon",
          cancelDraftTitle: "Annuler le brouillon ?",
          cancelDraftDesc:
            "Cette action réinitialisera votre progression et supprimera le brouillon enregistré.",
          cancelContinue: "Continuer",
          cancelConfirm: "Annuler le brouillon",
          calendarPrevMonth: "Mois précédent",
          calendarNextMonth: "Mois suivant",
          markerPickupAria: "Collecte",
          markerDeliveryAria: "Livraison",
          successTitle: "Commande confirmée !",
          successSubtitle: "Votre commande a été enregistrée avec succès",
          orderNumberLabel: "Numéro de commande",
          totalLabel: "Total:",
          methodLabel: "Méthode:",
          methodPickupFull: "Collecte & livraison à domicile",
          methodRelay: "Point relais",
          nextStepsTitle: "Prochaines étapes :",
          nextStepsEmailTo:
            "• Vous recevrez un email de confirmation à l'adresse",
          nextStepsPickup:
            "• Un professionnel viendra récupérer vos chaussures",
          nextStepsRelayCollect: "• Vos chaussures seront récupérées au relais",
          nextStepsRelayDepositPrefix:
            "• Déposez vos chaussures au point relais dans",
          nextStepsRelayDepositSuffix: "(avant",
          nextStepsNotified: "• Vous serez notifié une fois le service terminé",
          continueButton: "Continuer",
          myOrdersButton: "Mes commandes",
          confirmSubtitle: "Vérifiez et confirmez votre commande",
          // Step 2 guard when service missing
          step2ServiceMissingTitle: "Service non sélectionné",
          step2ServiceMissingDesc:
            "Veuillez sélectionner un service à l'étape précédente. Si le problème persiste, actualisez la page.",
          step2ServiceMissingRefresh: "Actualiser la page",
          // Compact deal suggestions
          dealSuggest: {
            belowMin: {
              titlePrefix: "Offre",
              add: "Ajoutez",
              pairs: "paire(s)",
              qualify: "pour en profiter",
              ctaPrefix: "Passer à",
              ctaPairs: "paires",
            },
            exactlyBuy: {
              title: "Paire offerte !",
              body: "Ajoutez votre paire gratuite",
              ctaPrefix: "Ajouter",
              ctaSuffix: "paire offerte",
            },
          },
        },
      },
      orders: {
        title: "Mes Commandes",
        filters: {
          statusAll: "Tous",
          statusLabel: "Statut",
          dateLabel: "Date",
          selectDate: "Sélectionner une date",
          reset: "Réinitialiser",
          filters: "Filtres",
          countSuffix: "commande(s)",
        },
        empty: "Aucune commande trouvée.",
        header: {
          order: "Commande",
          dateUnavailable: "Date non disponible",
        },
        labels: {
          pairsSuffix: "s",
          homePickup: "Collecte à domicile",
          relayPoint: "Point relais",
          pickupPlanned: "Collecte prévue",
          pickupSlot: "Créneau de collecte",
          pickupMethod: "Méthode de collecte",
          estimatedReturn: "Retour estimé",
          relayReturnEstimated: "Retour relais estimé",
          relayDepositAssumption:
            "Calcul basé sur dépôt estimé sous 48h après commande",
          deliverySlot: "Créneau de livraison",
          instructionsPrefix: "Instructions:",
          total: "Total",
          details: "Détails",
          hide: "Masquer",
          contactSupport: "Contacter le support",
          page: "Page",
          of: "sur",
          prev: "Précédent",
          next: "Suivant",
          cancelConfirm:
            "Confirmer l'annulation ? Le remboursement sera effectué  sous 24 à 48h.",
          cancelSuccess:
            "Commande annulée avec succès. Remboursement sous 24 à 48h.",
          cancelError: "Impossible d'annuler la commande.",
        },
        status: {
          pending: "En attente",
          pickup_scheduled: "Collecte planifiée",
          in_progress: "En cours",
          delivery_scheduled: "Livraison planifiée",
          completed: "Terminée",
          cancelled: "Annulée",
        },
      },
      events: {
        title: "Événements",
        instructions: {
          selectDate: "Sélectionnez une date pour voir les événements.",
        },
        legend: {
          title: "Légende",
          pickup: "Collecte",
          delivery: "Livraison",
          relayPending: "Activité Point relais",
        },
        headers: {
          upcoming: "À venir",
          past: "Passés",
        },
        empty: {
          forDate: "Aucun événement pour cette date.",
          planned: "Aucun événement planifié.",
        },
        modal: {
          collectDetails: "Détails de la collecte",
          deliveryDetails: "Détails de la livraison",
          eventDetails: "Détails de l'événement",
          close: "Fermer",
          reschedule: "Reprogrammer",
        },
        labels: {
          date: "Date",
          slot: "Créneau",
          method: "Méthode",
          amount: "Montant",
          address: "Adresse",
          relayPoint: "Point relais",
          additionalInfo: "Informations supplémentaires",
          instructions: "Instructions:",
          none: "—",
          homePickup: "À domicile",
          order: "Commande #",
          pair: "paire",
          pairs: "paires",
          collect: "Collecte",
          deliveryScheduled: "Livraison programmée",
          showAll: "Voir tout",
          calendar: "Calendrier",
          pickupMethod: "Mode de collecte",
          deliveryMethod: "Mode de livraison",
          relayPickup: "Point relais",
          relaySpotName: "Nom du point relais",
          relaySpotAddress: "Adresse du point relais",
          relaySpotContact: "Contact du point relais",
        },
      },
      payments: {
        title: "Paiements",
        subtitle: "Historique et moyens de paiement",
        loading: "Chargement des paiements...",
        errorFallback: "Erreur lors du chargement des paiements",
        noPayments: "Aucun paiement pour le moment",
        downloadReceipt: "Télécharger le reçu",
        showingRecent: "Affichage des 10 derniers paiements",
        summary: {
          totalPaid: "Total payé",
          pending: "En attente",
          transactions: "Transactions",
        },
        history: {
          title: "Historique des paiements",
          empty: "Aucun paiement pour le moment",
          table: {
            order: "Commande",
            date: "Date",
            method: "Méthode",
            amount: "Montant",
            status: "Statut",
            actions: "Actions",
          },
          actions: {
            pay: "Payer",
            viewReceipt: "Voir le reçu",
            downloadReceipt: "Télécharger le reçu",
          },
          pagination: {
            none: "Aucune donnée",
            perPage: "Par page",
            prev: "Précédent",
            next: "Suivant",
            display: "Affichage {start}–{end} sur {total}",
          },
        },
        methods: {
          credit_card: "Carte bancaire",
          card: "Carte bancaire",
          manual: "Paiement manuel",
          bank_transfer: "Virement bancaire",
          paypal: "PayPal",
          stripe: "Stripe",
        },
        status: {
          paid: "Payé",
          pending: "En attente",
          failed: "Échec",
          refunded: "Remboursé",
          refund_pending: "Remboursement en attente",
        },
      },
      profile: {
        title: "Mon Profil",
        subtitle: "Gérez vos informations personnelles et paramètres",
        connectedVia: "Connecté via",
        loading: "Chargement du profil...",
        loadError: "Erreur lors du chargement du profil",
        successUpdate: "Profil mis à jour avec succès",
        updateError: "Erreur lors de la mise à jour du profil",
        picture: {
          change: "Changer la photo",
        },
        info: {
          title: "Informations personnelles",
          subtitle: "Vos informations personnelles",
          edit: "Modifier",
          save: "Sauvegarder",
          cancel: "Annuler",
          fields: {
            firstName: "Prénom",
            lastName: "Nom",
            email: "Email",
            emailManagedBy: "(géré par {provider})",
            phone: "Téléphone",
            address: "Adresse",
            city: "Ville",
            postalCode: "Code postal",
            addressPlaceholder: "Entrez votre adresse complète...",
          },
          viewLabels: {
            fullName: "Nom complet",
            phoneUnknown: "Non renseigné",
            addressUnknown: "Non renseignée",
          },
        },
        security: {
          title: "Sécurité",
          subtitle: "Protégez votre compte",
          changePassword: "Changer le mot de passe",
          connectedVia: "Connecté via {provider}",
          oauthAccount: "Compte {provider}",
          oauthSecuredBy: "Votre compte est sécurisé par {provider}",
          form: {
            current: "Mot de passe actuel",
            new: "Nouveau mot de passe",
            confirmNew: "Confirmer le nouveau mot de passe",
            submit: "Changer le mot de passe",
            cancel: "Annuler",
            mismatch: "Les mots de passe ne correspondent pas",
            changeSuccess: "Mot de passe modifié avec succès",
            changeError: "Erreur lors de la modification du mot de passe",
            changeErrorWithHint:
              "Erreur lors de la modification du mot de passe. Vérifiez votre mot de passe actuel.",
          },
        },
        actions: {
          title: "Actions du compte",
          subtitle: "Actions sur votre compte",
          logout: {
            title: "Se déconnecter",
            description: "Fermer votre session en cours",
            error: "Erreur lors de la déconnexion",
          },
          delete: {
            title: "Supprimer mon compte",
            description: "Cette action est irréversible",
          },
        },
      },
      reschedule: {
        pickupSection: {
          title: "Collecte à domicile",
          dateLabel: "Date de collecte",
          addressLabel: "Adresse de collecte",
        },
        deliverySection: {
          title: "Livraison à domicile",
          dateLabel: "Date de livraison souhaitée",
          estimatedDateLabel: "Date de livraison estimée",
          selectPickupFirst: "Sélectionnez d'abord une date de collecte",
          estimatedDays: "Estimée à {days} jours après la collecte",
          estimatedPrefix: "Estimée à",
          estimatedSuffix: "jours après la collecte",
          addressLabel: "Adresse de livraison",
        },
        selected: "Sélectionné",
        timeSlotLabel: "Créneau horaire",
        addressPlaceholder: "Entrez votre adresse",
        deliveryAddressPlaceholder: "Entrez votre adresse de livraison",
        serviceZone:
          "Zone de service: Île-de-France (75, 77, 78, 91, 92, 93, 94, 95)",
        errors: {
          addressOutOfZone:
            "Adresse hors zone de service. Nous couvrons uniquement l'Île-de-France.",
          earlierDate:
            "Vous ne pouvez pas reprogrammer pour une date antérieure à la date actuelle.",
          earlierTimeSlot:
            "Vous ne pouvez pas reprogrammer pour un créneau horaire antérieur le même jour.",
        },
      },
    },
    serviceArea: {
      title: "Zone de service",
      subtitle: "Collecte et livraison disponibles dans ces départements :",
      legend: {
        center: "Centre (Paris)",
        covered: "Départements couverts",
        coverageZone: "Zone de couverture",
      },
      coveredHeading: "Départements Couverts",
      availableLabel: "Disponible",
      popup: {
        departmentPrefix: "Département",
        serviceAvailable: "Service disponible",
      },
      cta: {
        notCoveredQuestion: "Zone non couverte ?",
        contactUs: "Contactez-nous",
      },
    },
    // Auth (Signup/Login)
    auth: {
      common: {
        backHome: "Retour à l'accueil",
        or: "ou",
      },
      signup: {
        title: "Inscription",
        subtitle: "Rejoignez Lave Tes Baskets en quelques clics",
        firstNameLabel: "Prénom *",
        lastNameLabel: "Nom *",
        emailLabel: "Adresse e-mail *",
        passwordLabel: "Mot de passe *",
        confirmPasswordLabel: "Confirmer le mot de passe *",
        firstNamePlaceholder: "John",
        lastNamePlaceholder: "Doe",
        emailPlaceholder: "john.doe@example.com",
        passwordPlaceholder: "Minimum 8 caractères",
        confirmPasswordPlaceholder: "Répétez votre mot de passe",
        passwordRuleMin: "• Au moins 8 caractères",
        passwordRuleUpper: "• Au moins 1 lettre majuscule (A-Z)",
        passwordRuleLower: "• Au moins 1 lettre minuscule (a-z)",
        passwordRuleNumber: "• Au moins 1 chiffre (0-9)",
        passwordRuleSpecial: "• Au moins 1 caractère spécial (!@#$% etc.)",
        passwordsMatch: "Les mots de passe correspondent",
        acceptTermsPrefix: "J'accepte les",
        terms: "conditions d'utilisation",
        and: "et la",
        privacy: "politique de confidentialité",
        submit: "Créer mon compte",
        submitting: "Création du compte...",
        haveAccount: "Vous avez déjà un compte ?",
        loginCta: "Se connecter",
        createdToast:
          "Compte créé. Un code de vérification vous a été envoyé par email.",
        emailInUse: "Cette adresse email est déjà utilisée",
        signupError: "Erreur lors de l'inscription",
        serverError: "Erreur de connexion au serveur. Veuillez réessayer.",
        firstNameRequired: "Le prénom est requis",
        firstNameTooShort: "Le prénom doit contenir au moins 2 caractères",
        lastNameRequired: "Le nom est requis",
        lastNameTooShort: "Le nom doit contenir au moins 2 caractères",
        emailRequired: "L'email est requis",
        emailInvalid: "Format d'email invalide",
        passwordRequired: "Le mot de passe est requis",
        passwordInvalid:
          "Mot de passe invalide: minimum 8 caractères, au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial",
        confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
        confirmPasswordMismatch: "Les mots de passe ne correspondent pas",
        termsRequired: "Vous devez accepter les conditions d'utilisation",
      },
      login: {
        title: "Connexion",
        subtitle: "Accédez à votre espace Lave Tes Baskets",
        emailLabel: "Adresse e-mail",
        emailPlaceholder: "votre@email.com",
        passwordLabel: "Mot de passe",
        passwordPlaceholder: "Saisissez votre mot de passe",
        rememberMe: "Se souvenir de moi",
        forgotPassword: "Mot de passe oublié ?",
        submit: "Se connecter",
        submitting: "Connexion...",
        noAccount: "Pas encore de compte ?",
        createAccount: "Créer un compte",
        continueWithGoogle: "Continuer avec Google",
        continueWithFacebook: "Continuer avec Facebook",
        modalTitle: "Mot de passe oublié",
        modalInstruction:
          "Saisissez votre adresse e-mail. Nous vous enverrons un code OTP pour réinitialiser votre mot de passe.",
        cancel: "Annuler",
        sendOtp: "Envoyer le code OTP",
        sending: "Envoi...",
        genericError: "Une erreur est survenue",
        fetchUserError:
          "Erreur lors de la récupération des données utilisateur",
        invalidCreds: "Email ou mot de passe incorrect",
        serverError: "Erreur de connexion au serveur. Veuillez réessayer.",
      },
      // OAuth texts for signup
      // Placed under signup for consistency
      // Note: we keep login-specific versions too for better phrasing
      signupOAuth: {
        continueWithGoogle: "S'inscrire avec Google",
        continueWithFacebook: "S'inscrire avec Facebook",
      },
    },

    // Service Detail
    serviceDetail: {
      notFound: "Service non trouvé",
      backToServices: "Retour aux services",
      summary: "Résumé",
      duration: "Durée",
      price: "Prix",
      guarantee: "Garantie",
      detailedDescription: "Description détaillée",
      ourProcess: "Notre processus",
      materialsHandled: "Matières prises en charge",
      importantPrecautions: "Précautions importantes",
      serviceLimits: "Limites du service",
      bookService: "Réserver ce service",
    },

    // Catalog Section
    catalog: {
      badge: "Nos Transformations",
      title: "Avant / Après",
      subtitle:
        "Découvrez le résultat de notre expertise sur vos chaussures préférées",
      before: "Avant",
      after: "Après",
      previous: "Précédent",
      next: "Suivant",
      instructions: "Faites glisser le curseur pour voir la transformation",
      viewMore: "Voir plus",
      pageTitle: "Galerie Avant / Après",
      pageSubtitle:
        "Découvrez toutes nos réalisations et le savoir-faire de nos experts",
      backToHome: "Retour à l'accueil",
      seeResult: "Voir le résultat",
      seeBefore: "Revoir l'état initial",
      transforming: "Transformation...",
      items: [
        {
          title: "Sneakers Blanches",
          description: "Nettoyage professionnel complet",
        },
        {
          title: "Baskets de Running",
          description: "Restauration et protection",
        },
        {
          title: "Chaussures de Ville",
          description: "Finition luxe et cirage premium",
        },
      ],
    },

    // Subscriptions Section
    subscriptions: {
      badge: "Abonnements Premium",
      title: "Économisez avec nos abonnements",
      subtitle:
        "Profitez de tarifs préférentiels et de crédits mensuels pour l'entretien régulier de vos chaussures",
      loading: "Chargement des offres...",
      popular: "Populaire",
      billing: {
        monthly: "/ mois",
        quarterly: "/ trimestre",
        yearly: "/ an",
      },
      equivalent: "soit {price} / mois",
      creditsPerCycle: "crédits inclus",
      subscribe: "S'abonner",
      forService: "Pour le service : {service}",
      needHelp: "Besoin d'aide pour choisir ?",
      contactUs: "Contactez-nous",
    },

    // Subscription Dashboard
    subscription: {
      title: "Mon Abonnement",
      subtitle: "Gérez votre abonnement et vos crédits",
      refresh: "Actualiser",
      creditsBalance: "Solde de crédits",
      creditsByService: "Crédits par service",
      nextRenewal: "Prochain renouvellement",
      currentPlan: "Plan actuel",
      monthlyPrice: "Prix mensuel",
      month: "mois",
      creditsPerMonth: "Crédits par mois",
      periodStart: "Début de période",
      periodEnd: "Fin de période",
      cleanings: "nettoyage(s)",
      credit: "crédit",
      credits: "crédits",
      noSubscription: "Pas d'abonnement actif",
      noSubscriptionText:
        "Souscrivez à un abonnement pour bénéficier de crédits mensuels et d'économies sur vos nettoyages.",
      viewPlans: "Voir les offres",
      availablePlans: "Offres disponibles",
      choosePlan: "Choisissez votre abonnement",
      noPlansAvailable: "Aucune offre disponible pour le moment",
      popular: "Populaire",
      select: "Sélectionner",
      noEngagement: "Sans engagement, résiliable à tout moment",
      backToPlans: "Retour aux offres",
      confirmSubscription: "Confirmer votre abonnement",
      reviewDetails: "Vérifiez les détails avant de procéder au paiement",
      billing: "Facturation",
      monthly: "Mensuelle",
      includedFeatures: "Ce qui est inclus",
      termsTitle: "Conditions d'abonnement",
      termsText:
        "Votre abonnement sera renouvelé automatiquement chaque mois. Vous pouvez résilier à tout moment depuis votre espace profil. Les crédits d'abonnement non utilisés expirent après 3 mois, mais les crédits supplémentaires achetés n'expirent jamais.",
      proceedToPayment: "Procéder au paiement",
      paymentError: "Erreur lors de la création du paiement",
      cancel: "Annuler",
      cancelConfirmText: "Êtes-vous sûr de vouloir résilier votre abonnement ?",
      cancelAtPeriodEnd: "Résilier à la fin de la période",
      cancelImmediately: "Résilier immédiatement",
      keepSubscription: "Garder mon abonnement",
      cancelledAtPeriodEnd:
        "Votre abonnement sera résilié à la fin de la période en cours.",
      cancelledImmediately: "Votre abonnement a été résilié.",
      cancelError: "Erreur lors de la résiliation",
      cancelAtPeriodEndWarning: "Abonnement en cours de résiliation",
      cancelAtPeriodEndDate: "Votre abonnement prendra fin le",
      resume: "Reprendre l'abonnement",
      resumed: "Votre abonnement a été réactivé.",
      resumeError: "Erreur lors de la réactivation",
      creditHistory: "Historique des crédits",
      noHistory: "Aucun historique disponible",
      subscriptionSuccess: "Abonnement activé avec succès !",
      continue: "Continuer",
      confirmSubtitle:
        "Vérifiez les détails de votre abonnement avant de procéder au paiement",
      features: "services inclus",
      requirements: "Prérequis",
      limitations: "Limitations",
      status: {
        active: "Actif",
        cancelled: "Résilié",
        pastDue: "Paiement en retard",
        paused: "En pause",
      },
      history: {
        grant: "Crédit ajouté",
        use: "Crédit utilisé",
        expire: "Expiré",
        refund: "Remboursement",
      },
      // Subscription booking flow
      bookCleaning: "Réserver un nettoyage",
      creditsAvailable: "crédits disponibles",
      creditsRemaining: "crédits restants",
      bookCleaningTitle: "Réserver avec vos crédits",
      selectQuantity: "Quantité",
      howManyPairs: "Combien de paires souhaitez-vous nettoyer ?",
      youHave: "Vous avez",
      pair: "paire",
      pairs: "paires",
      creditWillBeUsed: "crédit sera utilisé",
      creditsWillBeUsed: "crédits seront utilisés",
      addPickupUpgrade: "Ajouter la collecte à domicile",
      pickupUpgradeDescription: "Nous venons chercher vos chaussures chez vous",
      pickupDetails: "Détails de collecte",
      confirmBooking: "Confirmer la réservation",
      reviewYourBooking: "Vérifiez votre réservation",
      service: "Service",
      quantity: "Quantité",
      creditsUsed: "Crédits utilisés",
      pickupSupplement: "Supplément collecte",
      pickupMethod: "Mode de collecte",
      supplementRequired: "Paiement supplémentaire requis",
      supplementDescription:
        "Vous serez redirigé vers la page de paiement pour le supplément collecte.",
      confirmAndPay: "Confirmer et payer",
      bookingSuccess: "Réservation confirmée avec succès !",
      bookingError: "Erreur lors de la réservation",
    },

    shots: {
      badge: "En direct du laboratoire",
      title: "Nos Lavages",
      subtitle:
        "Des résultats qui parlent d'eux-mêmes — avant et après en vidéo.",
      unmute: "Activer le son",
      mute: "Couper le son",
      viewMore: "Voir plus de vidéos",
      pageTitle: "Tous nos lavages",
      pageSubtitle: "Découvrez l'ensemble de nos transformations en vidéo.",
      back: "Retour",
    },
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      process: "Impact",
      pricing: "Pricing",
      contact: "Contact",
      faq: "FAQ",
    },
    // Common
    common: {
      prev: "Prev",
      next: "Next",
      pair: "pair",
      perPair: "per pair",
      hide: "Hide",
      loading: "Loading...",
      cancel: "Cancel",
      confirm: "Confirm",
    },

    // Hero Section
    hero: {
      title: "Your sneakers aren't old, they're just dirty",
      slogan: "Bring your favorite shoes back to life",
      description:
        "Build your custom cleaning: pick a base service, add your options — or request a personalized photo estimate.",
      cta: "Build my service",
      benefits: {
        collection: "Optional pickup & delivery",
        express: "48h express available",
        luxury: "Free photo estimate",
      },
      stats: {
        express: "Express",
        pairs: "Pairs processed",
        rating: "Average rating",
      },
      trustBadge: "4.9/5 - 1k+ pairs restored",
      testimonial: '⭐⭐⭐⭐⭐ "Amazing result!"',
    },

    // Services Section
    services: {
      title: "Our Services",
      learnMore: "Learn more",
      items: [
        {
          title: "Professional Cleaning",
          description:
            "Deep cleaning with specialized products for all types of shoes",
        },
        {
          title: "Collection & Delivery",
          description:
            "Add-on: we collect your pairs and bring them back, from €15",
        },
        {
          title: "Express Service",
          description: "Add-on: priority handling, back in 24h or 48h",
        },
        {
          title: "Premium Protection",
          description: "Add-on: long-lasting waterproofing, from €2 per pair",
        },
        {
          title: "Luxury Finish",
          description:
            "High-end finish with premium polish and careful packaging",
        },
        {
          title: "Business",
          description:
            "Volume sneaker cleaning for professionals: on-site pickup and monthly billing",
        },
      ],
    },

    // Impact Section
    impact: {
      title: "Our Impact",
      subtitle:
        "Every year, 24 billion shoes are produced. 90% end up in landfills. Together, let's change that.",
      cards: {
        lifespan: {
          title: "1,000 years in landfill",
          description:
            "A synthetic sole takes up to 1,000 years to decompose. By extending your shoes' life by 2-3 years, you prevent them from joining the 300 million pairs discarded annually in France.",
        },
        environmental: {
          title: "13.6 kg of CO₂ per pair",
          description:
            "Each new pair generates 13.6 kg of CO₂ and consumes 8,000 liters of water (MIT). The footwear industry accounts for 1.4% of global emissions — as much as air travel. Maintain, don't replace.",
        },
        time: {
          title: "Your time is precious",
          description:
            "Home pickup and delivery: zero travel, zero waiting. Get your shoes back like new effortlessly, while you enjoy your free time.",
        },
      },
      categories: {
        personal: {
          title: "Appearance",
          description:
            "Impeccable shoes that reflect your style and professionalism",
        },
        health: {
          title: "Hygiene",
          description:
            "Elimination of bacteria and allergens for healthier feet",
        },
        environmental: {
          title: "Planet",
          description: "Extend the life of your shoes and reduce textile waste",
        },
        economic: {
          title: "Economy",
          description:
            "Save money by maintaining rather than replacing your shoes",
        },
      },
      stats: {
        lifespan: {
          value: "+3 years",
          label: "Extended lifespan",
        },
        water: {
          value: "8,000L",
          label: "Water saved per pair",
        },
        waste: {
          value: "13.6kg",
          label: "CO₂ avoided per pair",
        },
        satisfaction: {
          value: "98%",
          label: "Satisfied customers",
        },
      },
    },

    // Process Section (removed - replaced by impact)
    /* process: {
      title: "Our Process",
      steps: [
        {
          title: "Booking",
          description: "Book your collection slot online or by phone",
        },
        {
          title: "Collection",
          description: "We come to collect your shoes at your home",
        },
        {
          title: "Cleaning",
          description: "Professional cleaning in our specialized workshop",
        },
        {
          title: "Delivery",
          description: "Your shoes are delivered clean and protected",
        },
      ],
    }, */

    // Service Area Section
    serviceArea: {
      title: "Service Area",
      subtitle: "Pickup and delivery available in these departments:",
      legend: {
        center: "Center (Paris)",
        covered: "Covered departments",
        coverageZone: "Coverage zone",
      },
      coveredHeading: "Covered Departments",
      availableLabel: "Available",
      popup: {
        departmentPrefix: "Department",
        serviceAvailable: "Service available",
      },
      cta: {
        notCoveredQuestion: "Not covered?",
        contactUs: "Contact us",
      },
    },

    // Pricing Section
    pricing: {
      title: "Pricing",
      duration: "Estimated duration:",
      popular: "Popular",
      choose: "Choose",
      savings: "Save",
      pickup: "Pickup and delivery included",
      requirements: "Requirements",
      limitations: "Limitations",
      description: "3 base services, your add-ons on top.",
      customService: "Need a custom service?",
      contactUs: "Contact us",
      pickupUpgrade: "Pickup & delivery available as an add-on",
      toggle: {
        services: "Services",
        subscriptions: "Subscriptions",
      },
      subscriptions: {
        month: "month",
        monthly: "/ month",
        quarterly: "/ quarter",
        yearly: "/ year",
        equivalent: "i.e. {price} / month",
        credits: "credits included",
        creditsPerMonth: "credits / month",
        cleaningsPerMonth: "cleanings / month",
        cleaning: "cleaning",
        forCleaningsPerMonth: "for {count} cleanings per month",
        serviceValue: "value {price} / credit",
        includedFeatures: "What's included",
        subscribe: "Subscribe",
        forService: "For service: {service}",
        plansFor: "Subscription Plans for",
        noEngagement: "No commitment, cancel anytime",
        needHelp: "Need help?",
        helpDescription:
          "Our advisors are here to help you choose the right subscription for your needs.",
      },
      plans: [
        {
          name: "Essential",
          price: "€20",
          description: "Standard cleaning for daily use",
          features: [
            "Professional cleaning",
            "Collection & delivery",
            "Standard 1 week turnaround",
            "Satisfaction guarantee",
          ],
          cta: "Choose this plan",
        },
        {
          name: "Premium",
          price: "€20",
          description: "Deep cleaning with protection",
          features: [
            "Professional cleaning",
            "Collection & delivery",
            "Express 4 days service",
            "Waterproofing protection",
            "Premium packaging",
            "Satisfaction guarantee",
          ],
          cta: "Choose this plan",
        },
        {
          name: "Luxury",
          price: "€45",
          description: "Ultra-fast premium service",
          features: [
            "Professional cleaning",
            "Collection & delivery",
            "Express 24h service",
            "Waterproofing protection",
            "Minor repairs",
            "Premium polish",
            "Luxury packaging",
            "Satisfaction guarantee",
          ],
          cta: "Choose this plan",
        },
      ],
    },

    // Contact Section
    contact: {
      title: "Contact Us",
      subtitle: "Ready to bring your shoes back to life?",
      infoTitle: "Contact Information",
      form: {
        title: "Send us a message",
        name: "Full name",
        email: "Email",
        phone: "Phone",
        service: "Desired service",
        message: "Message",
        submit: "Send message",
        success: "Thank you for your message! We'll get back to you soon.",
        placeholders: {
          name: "Your name",
          email: "your@email.com",
          phone: "+33 1 23 45 67 89",
          message: "Describe your needs...",
        },
      },
      info: {
        phone: "",
        email: "contact@lavetesbaskets.fr",
        address: "Paris, France",
        hours: "Mon-Sun: 8am-7pm",
      },
      infoLabels: {
        phone: "Phone",
        email: "Email",
        address: "Address",
        hours: "Hours",
      },
    },

    // Footer Section
    footer: {
      about: {
        title: "About",
        description:
          "Lave Tes Baskets is your professional shoe cleaning service. We bring your favorite sneakers back to life with advanced cleaning techniques.",
      },
      services: {
        title: "Services",
        items: [
          "Professional Cleaning",
          "Collection & Delivery",
          "Express Service",
          "Premium Protection",
          "Repair",
          "Luxury Finish",
        ],
      },
      contact: {
        title: "Contact",
        phone: "",
        email: "contact@lavetesbaskets.fr",
        address: "Paris, France",
      },
      social: {
        title: "Follow Us",
      },
      copyright: "© 2024 Lave Tes Baskets. All rights reserved.",
      bottomLinks: {
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        legal: "Legal Notice",
        faq: "FAQ",
      },
    },
    // Dashboard Section
    dashboard: {
      title: "Dashboard",
      hello: "Hello",
      language: "Language",
      logout: "Logout",
      closeMenu: "Close menu",
      defaultUser: "User",
      items: {
        booking: "Cleanings",
        cart: "Cart",
        orders: "Orders",
        events: "Events",
        shorts: "Washes",
        subscription: "Subscriptions",
        payments: "Payments",
        profile: "Profile",
      },
      // Deals banner translations
      deals: {
        banner: {
          datePrefix: "📅 From",
          dateConnector: "to",
        },
      },
      booking: {
        steps: {
          serviceTitle: "Choose your cleaning service",
          serviceSubtitle: "Select the service that best fits your needs",
          quantityTitle: "How many pairs would you like cleaned?",
          planningTitle: "Pickup & Scheduling",
          confirmTitle: "Confirmation",
        },
        labels: {
          loadingServices: "Loading services...",
          servicesError: "Error loading services",
          duration: "Duration:",
          days: "days",
          hours: "hours",
          pickupIncluded: "Pickup & delivery ✅",
          pickupNotIncluded: "❌ Pickup & delivery",
          requirements: "Requirements",
          limitations: "Limitations",
          pickupUpgradeBadge: "+10€ for pickup & delivery",
          clickToViewDetails: "Click to view details",
          features: "Included Services",
          readMore: "Read more",
          readLess: "Read less",
          popular: "Popular",
          customizable: "Customizable",
          addOptionsNext: "Add your options in the next step",
          customizeTitle: "Build your service",
          pairsLabel: "Number of pairs",
          summaryTitle: "Summary",
          discountLine: "Discount",
          optionsLine: "Options",
          totalLine: "Total",
          youSave: "You save",
          howManyPairs: "How many pairs would you like cleaned?",
          unitPrice: "Unit price",
          estimate: "Estimate",
          totalInclTax: "Total incl. tax",
          maxPairsNote: "Maximum 100 pairs per order",
          pickupQuestion: "Would you like pickup & delivery?",
          pickupUpgradeAdded: "+€10 added to total",
          pickupUpgradeLine: "Pickup & delivery",
          savings: "Savings",
          total: "Total",
          includedTitle: "What's included:",
          addressTitle: "Pickup & delivery address",
          useSavedAddress: "Use my saved address",
          useMyAddress: "Use my address",
          addressOutOfZone:
            "Address out of service area. We only cover Île-de-France (75, 77, 78, 91, 92, 93, 94, 95).",
          addressPlaceholder:
            "Enter your full address (street, city, postal code)...",
          addressHint: "Make sure the address is correct to avoid delays.",
          phoneLabel: "Phone",
          phoneHint: "We will use this number to contact you if needed.",
          pickupDeliveryTitle: "Pickup & Delivery",
          pickupSlotTitle: "Pickup slot",
          pickupDateLabel: "Pickup date",
          selected: "Selected",
          selectedPrefix: "Selected:",
          timeSlotLabel: "Time slot",
          specialInstructionsLabel: "Special instructions (optional)",
          specialInstructionsPlaceholder:
            "Details about access, floor, door code, etc...",
          relayChooseTitle: "Choose your relay point",
          relayInfoAlert:
            "This service does not offer home pickup & delivery. Drop off your shoes at one of our partner relay points within 48h to allow collection by our team.",
          relaySearchPlaceholder: "Search (address, city, postal code)",
          relayCityPlaceholder: "City",
          relayPostalPlaceholder: "Postal code",
          relayLoading: "Loading relay points...",
          relayEmpty:
            "No relay points found with these criteria. Try broadening your search.",
          openingHours: "Opening hours",
          pageLabel: "Page",
          stepperAria: "Order steps",
          progressSrPrefix: "Progress",
          stepPrefix: "Step",
          ofWord: "of",
          confirmationTitle: "Order confirmation",
          serviceSummaryTitle: "Service summary",
          estimatedTotal: "Estimated total",
          priceDetailsTitle: "Price details",
          priceService: "Service",
          pricePickupOption: "Pickup & delivery option",
          priceTotal: "Total",
          paymentNote: "Payment will be made at the end of the next step.",
          pickupDetailsTitle: "Pickup details",
          pickupHomeBadge: "Home pickup & delivery",
          relayBadge: "Relay point",
          relayDeadlineNote:
            "Timing: you have up to 48h to drop off your shoes at the chosen relay point after order confirmation.",
          relayDeadlineLabel: "Drop-off deadline:",
          specialInstructionsTitle: "Special instructions",
          submitCreating: "Creating order...",
          submitConfirm: "Confirm my order",
          proceedToPayment: "Proceed to payment",
          processingPayment: "Processing...",
          confirmEmailNote:
            "You will receive a confirmation email with your order summary.",
          headerTitle: "New cleaning order",
          headerSubtitle: "Set up your cleaning service in a few simple steps",
          cancelDraft: "Cancel draft",
          cancelDraftTitle: "Cancel draft?",
          cancelDraftDesc:
            "This will reset your progress and remove the saved draft.",
          cancelContinue: "Continue",
          cancelConfirm: "Cancel draft",
          calendarPrevMonth: "Previous month",
          calendarNextMonth: "Next month",
          markerPickupAria: "Pickup",
          markerDeliveryAria: "Delivery",
          successTitle: "Order confirmed!",
          successSubtitle: "Your order has been recorded successfully",
          orderNumberLabel: "Order number",
          totalLabel: "Total:",
          methodLabel: "Method:",
          methodPickupFull: "Home pickup & delivery",
          methodRelay: "Relay point",
          nextStepsTitle: "Next steps:",
          nextStepsEmailTo: "• You will receive a confirmation email at",
          nextStepsPickup: "• A professional will pick up your shoes",
          nextStepsRelayCollect:
            "• Your shoes will be collected at the relay point",
          nextStepsRelayDepositPrefix:
            "• Drop your shoes at the relay point within",
          nextStepsRelayDepositSuffix: "(before",
          nextStepsNotified:
            "• You will be notified once the service is completed",
          continueButton: "Continue",
          myOrdersButton: "My orders",
          confirmSubtitle: "Review and confirm your order",
          // Step 2 guard when service missing
          step2ServiceMissingTitle: "Service not selected",
          step2ServiceMissingDesc:
            "Please select a service in the previous step. If the issue persists, refresh the page.",
          step2ServiceMissingRefresh: "Refresh page",
          // Compact deal suggestions
          dealSuggest: {
            belowMin: {
              titlePrefix: "Deal",
              add: "Add",
              pairs: "pair(s)",
              qualify: "to qualify",
              ctaPrefix: "Go to",
              ctaPairs: "pairs",
            },
            exactlyBuy: {
              title: "Free pair!",
              body: "Add your free pair",
              ctaPrefix: "Add",
              ctaSuffix: "free pair",
            },
          },
        },
      },
      orders: {
        title: "My Orders",
        filters: {
          statusAll: "All",
          statusLabel: "Status",
          dateLabel: "Date",
          selectDate: "Select a date",
          reset: "Reset",
          filters: "Filters",
          countSuffix: "order(s)",
        },
        empty: "No orders found.",
        header: {
          order: "Order",
          dateUnavailable: "Date unavailable",
        },
        labels: {
          pairsSuffix: "s",
          homePickup: "Home pickup",
          relayPoint: "Relay point",
          pickupPlanned: "Pickup planned",
          pickupSlot: "Pickup slot",
          pickupMethod: "Pickup method",
          estimatedReturn: "Estimated return",
          relayReturnEstimated: "Estimated relay return",
          relayDepositAssumption:
            "Calculated based on deposit within 48h after order",
          deliverySlot: "Delivery slot",
          instructionsPrefix: "Instructions:",
          total: "Total",
          details: "Details",
          hide: "Hide",
          contactSupport: "Contact support",
          page: "Page",
          of: "of",
          prev: "Prev",
          next: "Next",
          cancelConfirm:
            "Confirm cancellation? Refund will be processed within 24–48h.",
          cancelSuccess: "Order cancelled successfully. Refund within 24–48h.",
          cancelError: "Unable to cancel the order.",
        },
        status: {
          pending: "Pending",
          pickup_scheduled: "Pickup scheduled",
          in_progress: "In progress",
          delivery_scheduled: "Delivery scheduled",
          completed: "Completed",
          cancelled: "Cancelled",
        },
      },
      events: {
        title: "Events",
        instructions: {
          selectDate: "Select a date to view events.",
        },
        legend: {
          title: "Legend",
          pickup: "Pickup",
          delivery: "Delivery",
          relayPending: "Relay Activity",
        },
        headers: {
          upcoming: "Upcoming",
          past: "Past",
        },
        empty: {
          forDate: "No events for this date.",
          planned: "No events planned.",
        },
        modal: {
          collectDetails: "Pickup details",
          deliveryDetails: "Delivery details",
          eventDetails: "Event details",
          close: "Close",
          reschedule: "Reschedule",
        },
        labels: {
          date: "Date",
          slot: "Time slot",
          method: "Method",
          amount: "Amount",
          address: "Address",
          relayPoint: "Relay point",
          additionalInfo: "Additional information",
          instructions: "Instructions:",
          none: "—",
          homePickup: "Home pickup",
          order: "Order #",
          pair: "pair",
          pairs: "pairs",
          collect: "Pickup",
          deliveryScheduled: "Delivery scheduled",
          showAll: "Show all",
          calendar: "Calendar",
          pickupMethod: "Pickup method",
          deliveryMethod: "Delivery method",
          relayPickup: "Relay point",
          relaySpotName: "Relay point name",
          relaySpotAddress: "Relay point address",
          relaySpotContact: "Relay point contact",
        },
      },
      reschedule: {
        pickupSection: {
          title: "Home pickup",
          dateLabel: "Pickup date",
          addressLabel: "Pickup address",
        },
        deliverySection: {
          title: "Home delivery",
          dateLabel: "Desired delivery date",
          estimatedDateLabel: "Estimated delivery date",
          selectPickupFirst: "Select a pickup date first",
          estimatedDays: "Estimated {days} days after pickup",
          estimatedPrefix: "Estimated",
          estimatedSuffix: "days after pickup",
          addressLabel: "Delivery address",
        },
        selected: "Selected",
        timeSlotLabel: "Time slot",
        addressPlaceholder: "Enter your address",
        deliveryAddressPlaceholder: "Enter your delivery address",
        serviceZone:
          "Service area: Île-de-France (75, 77, 78, 91, 92, 93, 94, 95)",
        errors: {
          addressOutOfZone:
            "Address out of service area. We only cover Île-de-France.",
          earlierDate:
            "You cannot reschedule to a date earlier than the current scheduled date.",
          earlierTimeSlot:
            "You cannot reschedule to an earlier time slot on the same day.",
        },
      },
      payments: {
        title: "Payments",
        subtitle: "Payment history and methods",
        loading: "Loading payments...",
        errorFallback: "Error loading payments",
        noPayments: "No payments yet",
        downloadReceipt: "Download receipt",
        showingRecent: "Showing last 10 payments",
        summary: {
          totalPaid: "Total paid",
          pending: "Pending",
          transactions: "Transactions",
        },
        history: {
          title: "Payment history",
          empty: "No payments yet",
          table: {
            order: "Order",
            date: "Date",
            method: "Method",
            amount: "Amount",
            status: "Status",
            actions: "Actions",
          },
          actions: {
            pay: "Pay",
            viewReceipt: "View receipt",
            downloadReceipt: "Download receipt",
          },
          pagination: {
            none: "No data",
            perPage: "Per page",
            prev: "Prev",
            next: "Next",
            display: "Showing {start}–{end} of {total}",
          },
        },
        methods: {
          credit_card: "Credit card",
          card: "Card",
          manual: "Manual payment",
          bank_transfer: "Bank transfer",
          paypal: "PayPal",
          stripe: "Stripe",
        },
        status: {
          paid: "Paid",
          pending: "Pending",
          failed: "Failed",
          refunded: "Refunded",
          refund_pending: "Refund pending",
        },
      },
      profile: {
        title: "My Profile",
        subtitle: "Manage your personal information and settings",
        connectedVia: "Connected via",
        loading: "Loading profile...",
        loadError: "Error loading profile",
        successUpdate: "Profile updated successfully",
        updateError: "Error updating profile",
        picture: {
          change: "Change photo",
        },
        info: {
          title: "Personal information",
          subtitle: "Your personal information",
          edit: "Edit",
          save: "Save",
          cancel: "Cancel",
          fields: {
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            emailManagedBy: "(managed by {provider})",
            phone: "Phone",
            address: "Address",
            city: "City",
            postalCode: "Postal code",
            addressPlaceholder: "Enter your full address...",
          },
          viewLabels: {
            fullName: "Full name",
            phoneUnknown: "Not provided",
            addressUnknown: "Not provided",
          },
        },
        security: {
          title: "Security",
          subtitle: "Protect your account",
          changePassword: "Change password",
          connectedVia: "Signed in with {provider}",
          oauthAccount: "{provider} account",
          oauthSecuredBy: "Your account is secured by {provider}",
          form: {
            current: "Current password",
            new: "New password",
            confirmNew: "Confirm new password",
            submit: "Change password",
            cancel: "Cancel",
            mismatch: "Passwords do not match",
            changeSuccess: "Password changed successfully",
            changeError: "Error changing password",
            changeErrorWithHint:
              "Error changing password. Check your current password.",
          },
        },
        actions: {
          title: "Account actions",
          subtitle: "Actions on your account",
          logout: {
            title: "Log out",
            description: "End your current session",
            error: "Error during logout",
          },
          delete: {
            title: "Delete my account",
            description: "This action is irreversible",
          },
        },
      },
    },
    // Auth (Signup/Login)
    auth: {
      common: {
        backHome: "Back to home",
        or: "or",
      },
      signup: {
        title: "Sign Up",
        subtitle: "Join Lave Tes Baskets in just a few clicks",
        firstNameLabel: "First name *",
        lastNameLabel: "Last name *",
        emailLabel: "Email address *",
        passwordLabel: "Password *",
        confirmPasswordLabel: "Confirm password *",
        firstNamePlaceholder: "John",
        lastNamePlaceholder: "Doe",
        emailPlaceholder: "john.doe@example.com",
        passwordPlaceholder: "Minimum 8 characters",
        confirmPasswordPlaceholder: "Repeat your password",
        passwordRuleMin: "• At least 8 characters",
        passwordRuleUpper: "• At least 1 uppercase letter (A-Z)",
        passwordRuleLower: "• At least 1 lowercase letter (a-z)",
        passwordRuleNumber: "• At least 1 number (0-9)",
        passwordRuleSpecial: "• At least 1 special character (!@#$% etc.)",
        passwordsMatch: "Passwords match",
        acceptTermsPrefix: "I accept the",
        terms: "terms of use",
        and: "and the",
        privacy: "privacy policy",
        submit: "Create my account",
        submitting: "Creating account...",
        haveAccount: "Already have an account?",
        loginCta: "Log in",
        createdToast:
          "Account created. A verification code has been sent to your email.",
        emailInUse: "This email address is already in use",
        signupError: "Error during signup",
        serverError: "Server connection error. Please try again.",
        firstNameRequired: "First name is required",
        firstNameTooShort: "First name must be at least 2 characters",
        lastNameRequired: "Last name is required",
        lastNameTooShort: "Last name must be at least 2 characters",
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format",
        passwordRequired: "Password is required",
        passwordInvalid:
          "Invalid password: minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number and 1 special character",
        confirmPasswordRequired: "Please confirm your password",
        confirmPasswordMismatch: "Passwords do not match",
        termsRequired: "You must accept the terms of use",
      },
      login: {
        title: "Login",
        subtitle: "Access your Lave Tes Baskets space",
        emailLabel: "Email address",
        emailPlaceholder: "your@email.com",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter your password",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        submit: "Log in",
        submitting: "Logging in...",
        noAccount: "Don't have an account yet?",
        createAccount: "Create an account",
        continueWithGoogle: "Continue with Google",
        continueWithFacebook: "Continue with Facebook",
        modalTitle: "Forgot password",
        modalInstruction:
          "Enter your email address. We'll send you an OTP code to reset your password.",
        cancel: "Cancel",
        sendOtp: "Send OTP code",
        sending: "Sending...",
        genericError: "An error occurred",
        fetchUserError: "Error fetching user data",
        invalidCreds: "Incorrect email or password",
        serverError: "Server connection error. Please try again.",
      },
      signupOAuth: {
        continueWithGoogle: "Sign up with Google",
        continueWithFacebook: "Sign up with Facebook",
      },
    },

    // Service Detail
    serviceDetail: {
      notFound: "Service not found",
      backToServices: "Back to services",
      summary: "Summary",
      duration: "Duration",
      price: "Price",
      guarantee: "Guarantee",
      detailedDescription: "Detailed description",
      ourProcess: "Our process",
      materialsHandled: "Materials handled",
      importantPrecautions: "Important precautions",
      serviceLimits: "Service limits",
      bookService: "Book this service",
    },

    // Catalog Section
    catalog: {
      badge: "Our Transformations",
      title: "Before / After",
      subtitle: "Discover the results of our expertise on your favorite shoes",
      before: "Before",
      after: "After",
      previous: "Previous",
      next: "Next",
      instructions: "Drag the slider to see the transformation",
      viewMore: "View more",
      pageTitle: "Before / After Gallery",
      pageSubtitle:
        "Discover all our work and the expertise of our professionals",
      backToHome: "Back to home",
      seeResult: "See the result",
      seeBefore: "See before",
      transforming: "Transforming...",
      items: [
        {
          title: "White Sneakers",
          description: "Complete professional cleaning",
        },
        {
          title: "Running Shoes",
          description: "Restoration and protection",
        },
        {
          title: "Dress Shoes",
          description: "Luxury finish and premium polish",
        },
      ],
    },

    // Subscriptions Section
    subscriptions: {
      badge: "Premium Subscriptions",
      title: "Save with our subscriptions",
      subtitle:
        "Enjoy preferential rates and monthly credits for regular shoe maintenance",
      loading: "Loading offers...",
      popular: "Popular",
      billing: {
        monthly: "/ month",
        quarterly: "/ quarter",
        yearly: "/ year",
      },
      equivalent: "i.e. {price} / month",
      creditsPerCycle: "credits included",
      subscribe: "Subscribe",
      forService: "For service: {service}",
      needHelp: "Need help choosing?",
      contactUs: "Contact us",
    },

    // Subscription Dashboard
    subscription: {
      title: "My Subscription",
      subtitle: "Manage your subscription and credits",
      refresh: "Refresh",
      creditsBalance: "Credits Balance",
      creditsByService: "Credits by service",
      nextRenewal: "Next renewal",
      currentPlan: "Current plan",
      monthlyPrice: "Monthly price",
      month: "month",
      creditsPerMonth: "Credits per month",
      periodStart: "Period start",
      periodEnd: "Period end",
      cleanings: "cleaning(s)",
      credit: "credit",
      credits: "credits",
      noSubscription: "No active subscription",
      noSubscriptionText:
        "Subscribe to get monthly credits and save on your cleanings.",
      viewPlans: "View plans",
      availablePlans: "Available plans",
      choosePlan: "Choose your subscription",
      noPlansAvailable: "No plans available at the moment",
      popular: "Popular",
      select: "Select",
      noEngagement: "No commitment, cancel anytime",
      backToPlans: "Back to plans",
      confirmSubscription: "Confirm your subscription",
      reviewDetails: "Review the details before proceeding to payment",
      billing: "Billing",
      monthly: "Monthly",
      includedFeatures: "What's included",
      termsTitle: "Subscription terms",
      termsText:
        "Your subscription will be automatically renewed each month. You can cancel anytime from your profile section. Unused subscription credits expire after 3 months, but add-on credits purchased never expire.",
      proceedToPayment: "Proceed to payment",
      paymentError: "Error creating payment",
      cancel: "Cancel",
      cancelConfirmText: "Are you sure you want to cancel your subscription?",
      cancelAtPeriodEnd: "Cancel at period end",
      cancelImmediately: "Cancel immediately",
      keepSubscription: "Keep my subscription",
      cancelledAtPeriodEnd:
        "Your subscription will be cancelled at the end of the current period.",
      cancelledImmediately: "Your subscription has been cancelled.",
      cancelError: "Error cancelling subscription",
      cancelAtPeriodEndWarning: "Subscription cancellation pending",
      cancelAtPeriodEndDate: "Your subscription will end on",
      resume: "Resume subscription",
      resumed: "Your subscription has been reactivated.",
      resumeError: "Error resuming subscription",
      creditHistory: "Credit history",
      noHistory: "No history available",
      subscriptionSuccess: "Subscription activated successfully!",
      continue: "Continue",
      confirmSubtitle:
        "Review your subscription details before proceeding to payment",
      features: "Included services",
      requirements: "Requirements",
      limitations: "Limitations",
      status: {
        active: "Active",
        cancelled: "Cancelled",
        pastDue: "Past due",
        paused: "Paused",
      },
      history: {
        grant: "Credit added",
        use: "Credit used",
        expire: "Expired",
        refund: "Refund",
      },
      // Subscription booking flow
      bookCleaning: "Book a cleaning",
      creditsAvailable: "credits available",
      creditsRemaining: "credits remaining",
      bookCleaningTitle: "Book with your credits",
      selectQuantity: "Quantity",
      howManyPairs: "How many pairs would you like to clean?",
      youHave: "You have",
      pair: "pair",
      pairs: "pairs",
      creditWillBeUsed: "credit will be used",
      creditsWillBeUsed: "credits will be used",
      addPickupUpgrade: "Add home pickup",
      pickupUpgradeDescription: "We'll pick up your shoes at your home",
      pickupDetails: "Pickup details",
      confirmBooking: "Confirm booking",
      reviewYourBooking: "Review your booking",
      service: "Service",
      quantity: "Quantity",
      creditsUsed: "Credits used",
      pickupSupplement: "Pickup supplement",
      pickupMethod: "Pickup method",
      supplementRequired: "Additional payment required",
      supplementDescription:
        "You will be redirected to the payment page for the pickup supplement.",
      confirmAndPay: "Confirm and pay",
      bookingSuccess: "Booking confirmed successfully!",
      bookingError: "Error during booking",
    },

    shots: {
      badge: "Live from the lab",
      title: "Our Cleanings",
      subtitle:
        "Results that speak for themselves — before and after on video.",
      unmute: "Unmute",
      mute: "Mute",
      viewMore: "View more videos",
      pageTitle: "All our cleanings",
      pageSubtitle: "Browse all our transformations on video.",
      back: "Back",
    },
  },
};

export const getTranslation = (language: string, key: string): string => {
  const keys = key.split(".");
  let translation: any = translations[language as keyof Translations];

  for (const k of keys) {
    if (translation && translation[k]) {
      translation = translation[k];
    } else {
      // Fallback to French if translation not found
      translation = translations.fr;
      for (const k of keys) {
        if (translation && translation[k]) {
          translation = translation[k];
        } else {
          return key; // Return key if no translation found
        }
      }
      break;
    }
  }

  return translation;
};
